// Demo.tsx

import React from 'react';
import GuidedDemo from './GuidedDemo';
import MobileGuidedDemo from './MobileGuidedDemo';

const ResponsiveDemo = ({ topoInstance, variant = 'desktop', onDemoStart }) => {
  if (variant === 'mobile') {
    return <MobileGuidedDemo topoInstance={topoInstance} onDemoStart={onDemoStart} />;
  }
  return <GuidedDemo topoInstance={topoInstance} />;
};

export default ResponsiveDemo;
